<app-loading-generico [loadingGenerico]="loadingGenerico"></app-loading-generico>
<app-header></app-header>
<app-botao-chat></app-botao-chat>

<div class="container py-4">
    <div class="row">
        <div class="col-12">

        <form [formGroup] = 'form'>
          <div class="card">
            <app-breadcrumb></app-breadcrumb>
            <h1 class="titulo">Relatório de usuários ativos </h1>
              <p class="paragrafo mb-4">Relatório para conferência por tipos de benefícios</p>

              <div class="content">
                  <i
                    class="fa fa-info-circle c-black fa-1x mt-1 ms-2 icone-padrao"
                    aria-hidden="true"
                    [popover]="myPopoverSpTrans"
                    popoverTitle="Cartões SPTrans"
                    popoverPlacement="top"
                    triggers="click"
                    [outsideClick]="true">
                  </i>

                  <ng-template #myPopoverSpTrans>
                    <span class="texto-tabela">
                      Relação de cartões Bilhete Único SPtrans relatório em CSV.
                    </span>
                  </ng-template>
                  <div class="col-lg-1">
                      <div class="mb-3">
                          <div class="switch__container">
                            <input id="switch-shadow" formControlName="switch" class="switch switch--shadow" type="checkbox" [checked]="spTrans" (change)="spTrans = !spTrans">
                            <label for="switch-shadow"></label>
                          </div>
                      </div>
                  </div>

                  <div class="col-lg-4">
                      <div class="mb-3">
                          <span class="fontCheckBox mt-1 text-nowrap">relatório de usuários com cartões sptrans</span>
                      </div>
                  </div>
              </div>

              <div class="row" >
                  <div class="col-lg-6">
                    <button [ngClass]="{ 'disabled': spTrans === false }" id="baixarRelatorioSp" [disabled]="spTrans === false"  type="button" (click)='baixarListaSptrans(idEmpresa , spTrans , bolsaCredito , idEndereco , idDepartamento , ordem , tipo)'
                    class="btn-borda-verde bnt-font-pequeno btn-pequeno ms-3" ><i class="fa fa-download me-2" aria-hidden="true"></i> Baixar relatório</button>
                  </div>
              </div>

              <div class="row mt-4">
                  <div class="col-lg-12">
                      <p class="label mt-3"> USUÁRIOS DE TODOS OS ENDEREÇOS </p>
                      <app-select
                        [form]="form"
                        name="enderecos"
                        id="slctUsuarioTodosEnderecos"
                        [options]="enderecosOptions"
                        defaultDescription="Usuários de todos os endereços"
                        defaultValue="0"
                        optionValue="value"
                        optionText="description">
                      </app-select>

                      <field-error [isError]="isErrorField('enderecos')"
                          message="Campo obrigatório">
                        </field-error>
                  </div>
              </div>

              <div class="row mt-4">
                  <div class="col-lg-6">
                      <p class="label mt-3"> Listar departamento</p>
                      <app-select
                      [form]="form"
                      name="idDepartamento"
                      id="slctListarDepartamento"
                      [options]="departamentos"
                      optionValue="idDepartamento"
                      optionText="descDepartamento"
                      defaultDescription="Usuários de todos os departamentos"
                      defaultValue="0">
                    </app-select>
                      <field-error [isError]="isErrorField('idDepartamento')"
                          message="Campo obrigatório">
                        </field-error>
                  </div>

                  <div class="col-lg-6">
                      <p class="label mt-3"> Ordem da listagem </p>
                      <app-select
                      [form]="form"
                      name="ordem"
                      id="slctOrdemListagem"
                      [options]="[
                      { description : 'Nome do usuário' ,
                        value : 'N'} ,
                        { description : 'Código da matrícula' ,
                        value : 'M'} ,
                        { description : 'Departamento e nome do usuário' ,
                        value : 'D'}
                      ]"
                      optionValue="value"
                      optionText="description">
                    </app-select>
                  </div>
              </div>

              <div class="row mt-4">
                  <div class="col-lg-6">
                      <p class="label mt-3"> Tipo do relatório</p>
                      <app-select
                      [form]="form"
                      name="tipo"
                      id="slctTipoRelatorio"
                      [options]="[
                      { description : 'Resumo por usuário' ,
                        value : 'A'} ,
                        { description : 'Resumo por produto ' ,
                        value : 'S'} ,
                        { description : 'Resumo por departamento' ,
                        value : 'D'}
                      ]"
                      optionValue="value"
                      optionText="description">
                    </app-select>
                  </div>

                  <div class="col-lg-6">
                    <div class="mt-4">
                      <fieldset>
                        <legend class="label-menor">TIPO</legend>
                        <div class="form-check form-check-inline">
                          <input type="radio" id="Csv" class="form-check-input" name="codigoTipoRelatorio"
                            [checked]="!radioButtonHtml"
                            (change)="radioButtonHtml = false"
                          >
                          <label class="form-check-label" for="Csv">CSV/EXCEL</label>
                        </div>
                        <div class="form-check form-check-inline">
                          <input type="radio" id="Html" class="form-check-input" name="codigoTipoRelatorio"
                            [checked]="radioButtonHtml"
                            (change)="radioButtonHtml = true"
                          >
                          <label class="form-check-label" for="Html">HTML</label>
                        </div>
                      </fieldset>
                  </div>
                  </div>
              </div>

              <div class="text-center mb-3 mt-5">
                  <button type="button" class="botaoLongo ajuste-botao" id="btnListar" (click)="hideSpTrans()"
                  (click)='getAllListaUsuario(idEmpresa , spTrans , bolsaCredito)' [ngClass]="{
                    'disabled': !form.valid || !('RelatoriosRelatorioDeUsuariosAtivos' | usuarioPermissao:'Imprimir' | async)
                  }" [disabled]="!form.valid || !('RelatoriosRelatorioDeUsuariosAtivos' | usuarioPermissao:'Imprimir' | async)">LISTAR</button>
              </div>
            </div>
    </form>

        </div>
    </div>
</div>
<app-footer></app-footer>

